import { render } from "./ResendPassword.vue?vue&type=template&id=77cc00a1"
import script from "./ResendPassword.vue?vue&type=script&lang=js"
export * from "./ResendPassword.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__